var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFavoriteOutline = function SvgFavoriteOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31,
    height: 27,
    fill: "none",
    viewBox: "0 0 27 31"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff00",
    stroke: "currentColor",
    d: "m21.12 29.991-.844-.704c-2.816-2.675-4.788-4.365-4.788-6.477 0-1.69 1.408-3.097 3.098-3.097.986 0 1.971.422 2.535 1.126.563-.704 1.548-1.126 2.534-1.126 1.69 0 3.098 1.267 3.098 3.097 0 2.112-1.972 3.802-4.788 6.477zm-18.304-1.83A2.816 2.816 0 0 1 0 25.345V2.816A2.806 2.806 0 0 1 2.816 0h1.408v9.856l3.52-2.112 3.52 2.112V0h8.449a2.816 2.816 0 0 1 2.816 2.816v12.785l-1.408-.113a8.455 8.455 0 0 0-7.322 12.673z"
  })));
};
export default SvgFavoriteOutline;